import { Board } from "../../../reducers/uploadedBoard";
import {
  MessagesAndNotesContainer,
  MessagesAndNotesRevisionContainer,
  SubTitle,
} from "./RevisionsStyles";
import { useAppSelector } from "../../../utils/hooks/store";
import React, { useContext } from "react";
import {
  BoardIdContext,
  BoardShipmentIds,
} from "../../../utils/hooks/commonly-stored/uploaded-board/state-machine/reviewBoardFlowLoader";
import { InputLabel } from "../../../constants/Styles";
import MessageList from "../../ReviewBoardFlow/Quote/CustomerMessages/MessageList";

function RevisionMessageAndNotes({
  board,
  title,
}: {
  board: Board;
  title: string;
}) {
  return (
    <MessagesAndNotesRevisionContainer>
      <SubTitle>{title}</SubTitle>
      <div>
        <InputLabel>Previous revision notes:</InputLabel>
        <div>
          {board.manufacturing_details.customer_specifications.notes || "-"}
        </div>
      </div>
      <div>
        <InputLabel>Messages:</InputLabel>
        <MessageList boardId={board.id} />
      </div>
    </MessagesAndNotesRevisionContainer>
  );
}

export default function MessagesAndNotes({
  previousRevision,
}: {
  previousRevision: Board | null;
}) {
  const { boardId } = useContext(BoardIdContext) as BoardShipmentIds;
  const board = useAppSelector(
    (state) => state.uploadedBoard.boards[boardId]!.board as Board,
  );

  return (
    <MessagesAndNotesContainer>
      {previousRevision !== null && (
        <RevisionMessageAndNotes
          board={previousRevision}
          title={"Previous revision"}
        />
      )}
      <RevisionMessageAndNotes board={board} title={"Current revision"} />
    </MessagesAndNotesContainer>
  );
}
